<template>
    <v-input
        :label="labelText"
        class="trans-textarea-input"
        :error-messages="fieldErrors"
    >
        <template slot="default">
            <div class="w-100">
                <v-tabs v-model="selectedLang">
                    <v-tab v-for="lang in languages" :key="lang">
                        {{ lang }}
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="selectedLang">
                    <v-tab-item
                        v-for="lang in languages"
                        :key="lang"
                        :transition="false"
                        :reverse-transition="false"
                    >
                        <textarea-input
                            v-validate="validators"
                            :value="value[lang] ? value[lang][field] : ''"
                            :name="name + '_' + lang"
                            :data-vv-as="$t(label)"
                            :disabled="disabled"
                            :auto-grow="autoGrow"
                            @input="onInput($event, lang)"
                        ></textarea-input>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </v-input>
</template>

<script>
import TextareaInput from '@/components/form/Inputs/TextareaInput'
import TranslatableInputMixin from '@/components/form/Inputs/InputMixins/TranslatableInputMixin'

export default {
    components: {
        TextareaInput,
    },
    mixins: [TranslatableInputMixin],

    props: {
        autoGrow: {
            type: Boolean,
            default: true,
        },
        noResize: Boolean,
    },
}
</script>

<style lang="scss">
.trans-textarea-input .v-input__slot {
    flex-direction: column;
    align-items: flex-start;
}
.v-input--is-disabled:not(.v-input--is-readonly) {
    pointer-events: auto !important;
}
</style>
